/**
 * @deprecated
 *
 * This is a class scheduled for removal. Please use MonitorModern instead. It is here for the reference only,
 * and will be removed by the end of 2025.
 */

import { graphql, withApollo } from '@apollo/client/react/hoc';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import CacheManager from '@/graph/cacheManager';

import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router';
import { compose, mapProps } from 'recompose';
import styled, { css } from 'styled-components';
import closing from '../../../../assets/sound/closing.mp3';

import discharge from '../../../../assets/sound/discharge.mp3';
import holdProcedure from '../../../../assets/sound/holdProcedure.mp3';
import blockNerve from '../../../../assets/sound/holdProcedure.mp3'; // change to blockNerve sound
import help from '../../../../assets/sound/holdProcedure.mp3'; // change to help sound
import orReady from '../../../../assets/sound/orReady.mp3';
import readyToPickup from '../../../../assets/sound/readyToPickup.mp3';
import waitingReady from '../../../../assets/sound/waitingReady.mp3';
import procedureEnd from '../../../../assets/sound/procedureEnd.mp3';
import { withScope } from '@/contexts/ScopeContext';
import { getGlobalAvgTimesConfiguration } from '@/graph/procedureTypes';
import { listSubscription } from '@/graph/rooms';
import { isArray, isDefinedAndNotNull } from '@/se/utilities/check';
import { getNestedValue } from '@/se/utilities/data/object';
import responsive from '@/se/utilities/responsive';
import { withSession } from '@/state/Session';
import ClientUpdater from '../../../ClientUpdater';
import {
  createMapOfRoomsByType,
  mapFamilyReadyPACU,
  mapFamilyReadyPOSTOP,
  mapMonitorOperationRoom,
  mapMonitorRoom,
  mapORReady,
  mapPacuReady,
  mapPostOpReady,
  mapPrepReady,
  mapWaitingReady,
  monitorHideProcedureType,
  monitorHideProcedureTypeMessagingView,
} from '../../../entities/room/transducers';
import { unpackSessionObject } from '../../unpackSessionObject';
import MonitorContent from './MonitorContent';
import { MonitorNew } from '@/components/pages/kiosk/monitor/MonitorNew';
import { playSound } from '@/components/pages/kiosk/monitor/hooks/useAlerts';

export const PanelsStatus = styled.div`
  display: flex;
  margin-left: -0.25rem;
  margin-right: -0.25rem;
  flex: 1 1 50%;

  > div {
    margin: 0.25rem;
  }

  ${responsive.sm.andSmaller`
    flex-flow: column;
  `};

  ${props =>
    props.wrap &&
    css`
      flex-wrap: wrap;
      flex: 1 1 50%;
    `}

  ${props =>
    props.miniView &&
    css`
      flex: 0 0 50%;
    `}

  ${props =>
    props.moreSpace &&
    css`
      flex: 0 0 80%;
    `}
`;

export const sum = arr => arr.reduce((l, r) => l + r, 0);

export const soundAlert = playSound;

class __DEPRECATED__Monitor extends React.Component {
  constructor(props) {
    super(props);
    this.cacheManager = null;
  }

  componentDidMount() {
    // Initialize CacheManager once when component mounts and client is available
    if (!this.cacheManager && this.props.client) {
      console.log('🔧 Initializing CacheManager');
      this.cacheManager = new CacheManager(this.props.client);
    }
  }

  componentDidUpdate(prevProps, _prevState, _snapshot) {
    // Initialize CacheManager if it wasn't available in componentDidMount
    if (!this.cacheManager && this.props.client) {
      console.log('🔧 Initializing CacheManager');
      this.cacheManager = new CacheManager(this.props.client);
    }

    // Monitor cache and purge if needed based on patient count changes
    if (this.cacheManager && !this.props.loading) {
      const roomData = {
        waitingRoom: this.props.waitingRoom,
        preOp: this.props.preOp,
        pacu: this.props.pacu,
        postOps: this.props.postOps,
        operationRooms: this.props.operationRooms,
      };

      this.cacheManager.monitorAndPurge(roomData);
    } else if (!this.cacheManager) {
      console.log('❌ CacheManager not initialized - no Apollo client available');
      console.log('Props keys:', Object.keys(this.props));
    }

    if (!prevProps.loading) {
      if (this.prepWaitingNumberFromProps(this.props) > this.prepWaitingNumberFromProps(prevProps)) {
        this.readyForPrepReadyAlert().then();
      }

      if (this.readyForORNumberFromProps(this.props) > this.readyForORNumberFromProps(prevProps)) {
        this.readyForORAlert().then();
      }

      if (this.readyForSurgeonNumberFromProps(this.props) > this.readyForSurgeonNumberFromProps(prevProps)) {
        this.readyForSurgeonAlert().then();
      }

      if (this.holdProcedureNumberFromProps(this.props) > this.holdProcedureNumberFromProps(prevProps)) {
        this.holdProcedureAlert().then();
      }

      if (this.blockNerveNumberFromProps(this.props) > this.blockNerveNumberFromProps(prevProps)) {
        this.blockNerveAlert().then();
      }
      if (this.blockNerveNumberFromProps2(this.props) > this.blockNerveNumberFromProps2(prevProps)) {
        this.blockNerveAlert().then();
      }

      if (this.helpNumberFromProps(this.props) > this.helpNumberFromProps(prevProps)) {
        this.helpAlert().then();
      }

      if (this.pacuWaitingNumberFromProps(this.props) > this.pacuWaitingNumberFromProps(prevProps)) {
        this.readyToSeeFamilyAlert().then();
      }

      if (this.postOpWaitingNumberFromProps(this.props) > this.postOpWaitingNumberFromProps(prevProps)) {
        this.readyToSeeFamilyAlert().then();
      }

      if (this.familyHereNumberFromProps(this.props) > this.familyHereNumberFromProps(prevProps)) {
        this.familyHereAlert().then();
      }

      if (this.readyToPickupNumberFromProps(this.props) > this.readyToPickupNumberFromProps(prevProps)) {
        this.readyToPickupAlert().then();
      }

      if (this.procedureEndProps(this.props) > this.procedureEndProps(prevProps)) {
        this.procedureEndAlert().then();
      }

      if (this.closingProps(this.props) > this.closingProps(prevProps)) {
        this.closingAlert().then();
      }

      if (this.patientNumberFromProps(this.props) < this.patientNumberFromProps(prevProps)) {
        this.dischargeAlert().then();
      }
    }
  }

  readyForPrepReadyAlert = () => soundAlert(waitingReady, getNestedValue('configuration.prepReadySound', this.props));
  readyForORAlert = () => soundAlert(orReady, getNestedValue('configuration.orReadySound', this.props));
  readyForSurgeonAlert = () =>
    soundAlert(waitingReady, getNestedValue('configuration.readyForSurgeonSound', this.props));
  holdProcedureAlert = () => soundAlert(holdProcedure, getNestedValue('configuration.holdProcedureSound', this.props));
  blockNerveAlert = () => soundAlert(blockNerve, getNestedValue('configuration.blockNerveSound', this.props));
  helpAlert = () => soundAlert(help, getNestedValue('configuration.helpSound', this.props));
  readyToSeeFamilyAlert = () => soundAlert(waitingReady, getNestedValue('configuration.pacuReadySound', this.props));
  familyHereAlert = () => soundAlert(waitingReady, getNestedValue('configuration.waitingReadySound', this.props));
  readyToPickupAlert = () => soundAlert(readyToPickup, getNestedValue('configuration.readyToPickupSound', this.props));
  dischargeAlert = () => soundAlert(discharge, getNestedValue('configuration.dischargeSound', this.props));
  procedureEndAlert = () => soundAlert(procedureEnd, getNestedValue('configuration.procedureEndSound', this.props));
  closingAlert = () => soundAlert(closing, getNestedValue('configuration.closingSound', this.props));

  patientNumberFromProps = ({ operationRooms = [], waitingRoom, preOp, pacu, postOp }) =>
    sum([
      (getNestedValue('patients', waitingRoom) || []).length,
      (getNestedValue('patients', preOp) || []).length,
      (getNestedValue('patients', pacu) || []).length,
      (getNestedValue('patients', postOp) || []).length,
      sum(operationRooms.map(or => (getNestedValue('patients', or) || []).length)),
    ]);

  closingProps = ({ operationRooms = [] }) =>
    operationRooms.filter(or => getNestedValue('status', or) === 'Closing').length;
  procedureEndProps = ({ operationRooms = [] }) =>
    operationRooms.filter(or => getNestedValue('status', or) === 'ProcedureEnd').length;
  patientRoomNumberFromProps = type => props => {
    const value = props[type];

    if (!value) {
      return 0;
    }

    return (Array.isArray(value) ? value : [value])
      .map(v => {
        const patients = getNestedValue('patients', v);

        if (Array.isArray(patients)) {
          return patients.filter(_ => _.ready).length;
        }

        return 0;
      })
      .reduce((acc, curr) => acc + curr, 0);
  };

  waitingNumberFromProps = this.patientRoomNumberFromProps('waitingRoom');
  pacuWaitingNumberFromProps = this.patientRoomNumberFromProps('pacu');
  postOpWaitingNumberFromProps = this.patientRoomNumberFromProps('postOps');
  prepWaitingNumberFromProps = this.patientRoomNumberFromProps('waitingRoom');

  readyForSurgeonNumberFromProps = props => {
    const patients = getNestedValue('patients', props['preOp']) || {};
    if (Array.isArray(patients)) {
      return patients.filter(_ => _.readyForSurgeon).length;
    }
    return 0;
  };

  holdProcedureNumberFromProps = props => {
    const patients = getNestedValue('patients', props['preOp']) || {};
    if (Array.isArray(patients)) {
      return patients.filter(_ => _.isHoldProcedure).length;
    }
    return 0;
  };

  blockNerveNumberFromProps = props => {
    const patients = getNestedValue('patients', props['preOp']) || {};
    if (Array.isArray(patients)) {
      return patients.filter(_ => _.isBlockNerve).length;
    }
    return 0;
  };

  blockNerveNumberFromProps2 = props => {
    const postOps = (props['postOps'] || []).flatMap(postOp => getNestedValue('patients', postOp) || []);
    const pacu = getNestedValue('patients', props['pacu']) || [];

    return [...postOps, ...pacu].filter(_ => Boolean(_.isBlockNerve)).length;
  };

  helpNumberFromProps = props => {
    const patients = getNestedValue('patients', props['OR']) || {};
    if (Array.isArray(patients)) {
      return patients.filter(_ => _.isHelp).length;
    }
    return 0;
  };

  readyForORNumberFromProps = props => {
    const patients = getNestedValue('patients', props['preOp']) || {};
    if (Array.isArray(patients)) {
      return patients.filter(p => p.readyForOr).length;
    }
    return 0;
  };
  familyHereNumberFromProps = props => {
    const postOps = (props['postOps'] || []).flatMap(postOp => getNestedValue('patients', postOp) || []);
    const pacu = getNestedValue('patients', props['pacu']) || [];

    return [...postOps, ...pacu].filter(
      _ => Boolean(_.familyReady) || Boolean(_.familyReadyPACU) || Boolean(_.familyReadyPOSTOP)
    ).length;
  };

  readyToPickupNumberFromProps = props => {
    const postOps = (props['postOps'] || []).flatMap(postOp => getNestedValue('patients', postOp) || []);
    const pacu = getNestedValue('patients', props['pacu']) || [];

    return [...postOps, ...pacu]?.filter(_ => !!_.caretakerMessages).length;
  };

  render() {
    const { scope, operationRooms, waitingRoom, preOp, pacu, postOps, configuration, staffMode } = this.props;
    const hospitalId = scope?.hospital?.id;
    const hasPreOpPriorityModule = scope?.hospital?.modules?.preOpPriority?.hasPreOpPriority || false;
    const hasNoteModule = scope?.hospital?.modules?.noteTablet || false;

    const showPatientTypes = configuration?.showPatientTypes;

    const filterPatients = room => {
      if (!room || !room.patients) return room;
      if (!showPatientTypes || showPatientTypes.length === 0) {
        return room;
      }
      return { ...room, patients: room.patients.filter(p => showPatientTypes.includes(p.type)) };
    };

    const filterOperationRoom = room => {
      if (!room) return room;
      if (!showPatientTypes || showPatientTypes.length === 0) {
        return room;
      }
      return {
        ...room,
        patient: room.patient && showPatientTypes.includes(room.patient.type) ? room.patient : null,
        patients: room.patients ? room.patients.filter(p => showPatientTypes.includes(p.type)) : [],
      };
    };

    const filteredOperationRooms = operationRooms.map(filterOperationRoom);
    const filteredWaitingRoom = filterPatients(waitingRoom);
    const filteredPreOp = filterPatients(preOp);
    const filteredPacu = filterPatients(pacu);
    const filteredPostOps = filterPatients(postOps);

    const roomsWithOrder = filteredOperationRooms
      .filter(room => room?.order !== null)
      .sort((a, b) => a.order - b.order);
    const roomsWithoutOrder = filteredOperationRooms.filter(room => room?.order === null);

    const orderedRooms = [
      ...roomsWithOrder,
      ...roomsWithoutOrder.filter(room => room?.name?.toUpperCase()?.startsWith('OR')),
      ...roomsWithoutOrder.filter(room => !room?.name?.toUpperCase()?.startsWith('OR')),
    ];

    const staffCostAccess = this.props.session?.account?.metadata?.staffCostAccess;

    const showStaffTracking =
      scope?.hospital?.modules?.showStaffTracking &&
      (this.props.isSuperAdmin || staffCostAccess || (configuration?.showStaffIndicators && this.props.isKiosk));

    return (
      <Fragment>
        <Helmet>
          <meta name="viewport" content="width=1200, initial-scale=0" />
        </Helmet>
        {staffMode ? (
          <MonitorContent
            operationRooms={orderedRooms}
            waitingRoom={filteredWaitingRoom}
            preOp={filteredPreOp}
            pacu={filteredPacu}
            postOps={filteredPostOps}
            hasPostop={scope?.hospital?.modules?.hasPostop && configuration?.showPostOp !== false}
            hospitalId={hospitalId}
            preOpFocused={configuration?.preOpFocused}
            pacuFocused={configuration?.pacuFocused}
            hasNoteModule={hasNoteModule}
            hasPreOpPriorityModule={hasPreOpPriorityModule}
            isMini={false}
            isSuperAdmin={this.props.isSuperAdmin}
            isLiaison={this.props.isLiaison}
            messagingView={configuration?.messagingScreen}
            scope={scope}
            staffMode={staffMode}
            showScheduledProcedureDuration={configuration?.showScheduledProcedureDuration}
            showLatePreOpIndicator={configuration?.showLatePreOpIndicator || !this.props.isKiosk}
            showStaffTracking={showStaffTracking}
            isGroupAdmin={this.props.isGroupAdmin}
          />
        ) : (
          <MonitorContent
            operationRooms={orderedRooms}
            waitingRoom={filteredWaitingRoom}
            preOp={filteredPreOp}
            pacu={filteredPacu}
            postOps={filteredPostOps}
            hasPostop={scope?.hospital?.modules?.hasPostop && configuration?.showPostOp !== false}
            hospitalId={hospitalId}
            preOpFocused={configuration?.preOpFocused}
            pacuFocused={configuration?.pacuFocused}
            hasNoteModule={hasNoteModule}
            hasPreOpPriorityModule={hasPreOpPriorityModule}
            isMini={false}
            isSuperAdmin={this.props.isSuperAdmin}
            isLiaison={this.props.isLiaison}
            messagingView={configuration?.messagingScreen}
            scope={scope}
            showScheduledProcedureDuration={configuration?.showScheduledProcedureDuration}
            showLatePreOpIndicator={configuration?.showLatePreOpIndicator || !this.props.isKiosk}
            showStaffTracking={showStaffTracking}
            isGroupAdmin={this.props.isGroupAdmin}
          />
        )}
        {[...orderedRooms, filteredWaitingRoom, filteredPreOp, filteredPacu, filteredPostOps]
          .filter(room => room && room.patients)
          .every(({ patients = [] }) => patients.length <= 0) && <ClientUpdater />}
      </Fragment>
    );
  }
}

__DEPRECATED__Monitor.defaultProps = {
  operationRooms: [],
  waitingRoom: {},
  pacu: {},
  preOp: {},
  postOps: [],
};

__DEPRECATED__Monitor.propTypes = {
  operationRooms: PropTypes.array,
  waitingRoom: PropTypes.object,
  pacu: PropTypes.object,
  preOp: PropTypes.object,
  postOp: PropTypes.array,
};

const flattenRoomPatients = rooms =>
  rooms
    .map(_ => mapMonitorRoom(_))
    .reduce((acc, curr) => ({
      ...acc,
      patients: [...acc.patients, ...curr.patients],
      capacity: acc.capacity + curr.capacity,
    }));

const flattenRoomPatients2 = rooms => rooms.map(_ => mapMonitorRoom(_));

const injectExpectedWRDuration = (wrRoom, expectedWRDuration) => [
  {
    ...wrRoom[0],
    patients: (wrRoom[0].patients || []).map(p => ({
      ...p,
      procedureType: {
        ...p.procedureType,
        expectedWRDuration: get(expectedWRDuration, 'averageTimesConfiguration.expectedWRDuration', undefined),
      },
    })),
  },
];

export default compose(
  withRouter,
  withSession(unpackSessionObject),
  // branch(({ version }) => version === 'protobuf', renderComponent(ProtobufMonitor)),
  graphql(listSubscription),
  mapProps(({ data, ...rest }) => ({
    internalMonitor: isDefinedAndNotNull(data) ? data['internalMonitor'] || [] : [],
    error: data.error,
    loading: data.loading,
    ...rest,
  })),
  withScope,
  mapProps(({ internalMonitor, isLiaison, ...rest }) => ({
    internalMonitor: isLiaison
      ? monitorHideProcedureTypeMessagingView(internalMonitor, !getNestedValue('configuration.showProcedure', rest))
      : monitorHideProcedureType(internalMonitor, !getNestedValue('configuration.showProcedure', rest)),
    isLiaison,
    ...rest,
  })),
  mapProps(({ internalMonitor, patientNameFormat, scope, ...rest }) => ({
    ...createMapOfRoomsByType(
      internalMonitor,
      patientNameFormat,
      get(scope, 'hospital.id'),
      get(scope, 'hospital.groupId')
    ),
    scope,
    ...rest,
  })),
  graphql(getGlobalAvgTimesConfiguration),
  mapProps(({ data, operationRooms, waitingRooms, preOps, pacus, postOps, ...rest }) => ({
    ...rest,
    operationRooms: isArray(operationRooms) ? operationRooms.map(mapMonitorOperationRoom) : [],
    waitingRoom: isArray(waitingRooms) ? flattenRoomPatients(injectExpectedWRDuration(waitingRooms, data)) : undefined,
    preOp: isArray(preOps) ? flattenRoomPatients(preOps) : undefined,
    pacu: isArray(pacus) ? flattenRoomPatients(pacus) : undefined,
    // flattenRoomPatients2 will return array of post ops, flattenRoomPatients will reduce to one room
    postOps: isArray(postOps) ? flattenRoomPatients2(postOps) : undefined,
  })),
  mapProps(({ waitingRoom, operationRooms, preOp, pacu, postOps, ...rest }) => {
    // this config is named wrong showOrRooms because previously it is used only for or rooms
    const config = rest?.configuration?.showOrRooms || [];
    const showPatientTypes = rest?.configuration?.showPatientTypes;

    const isConfigEmptyOrIncludes = id => !config || config.length === 0 || config.includes(id);

    const filterPatients = room => {
      if (!room || !room.patients) return room;
      if (!showPatientTypes || showPatientTypes.length === 0) return room;
      return { ...room, patients: room.patients.filter(p => showPatientTypes.includes(p.type)) };
    };

    const filterOperationRoom = room => {
      if (!room) return room;
      if (!showPatientTypes || showPatientTypes.length === 0) return room;
      return {
        ...room,
        patient: room.patient && showPatientTypes.includes(room.patient.type) ? room.patient : null,
        patients: room.patients ? room.patients.filter(p => showPatientTypes.includes(p.type)) : [],
      };
    };

    return {
      ...rest,
      waitingRoom: isConfigEmptyOrIncludes(waitingRoom?.id) ? mapWaitingReady(filterPatients(waitingRoom)) : null,
      operationRooms:
        config && config.length > 0
          ? mapORReady(operationRooms)
              .filter(r => config.includes(r.id))
              .map(filterOperationRoom)
          : mapORReady(operationRooms).map(filterOperationRoom),
      preOp: isConfigEmptyOrIncludes(preOp?.id) ? mapPrepReady(filterPatients(preOp)) : null,
      pacu: isConfigEmptyOrIncludes(pacu?.id) ? mapFamilyReadyPACU(mapPacuReady(filterPatients(pacu))) : null,
      postOps: (postOps ?? [])
        .filter(e => isConfigEmptyOrIncludes(e?.id))
        .map(postOp => mapFamilyReadyPOSTOP(mapPostOpReady(filterPatients(postOp)))),
    };
  }),
  withApollo
)(MonitorNew);
